const axios = require('axios')
import TokenStorage from '@/js/TokenStorage'

const hostname = (process.env.NODE_ENV === 'development' ?
  location.hostname + ':18181' :
  'api-panda.a7.srv.br')

const protocol = (process.env.NODE_ENV === 'development' ?
  'http' :
  'https')

const axiosInstance = axios.create({
  baseURL: `${protocol}://${hostname}`
})

axiosInstance.interceptors.request.use((config) => {
  config.headers['Current-Site'] = axiosInstance.currentSite
  let token = TokenStorage.loadAuthToken()
  if (token) {
    config.headers.Authorization = token
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

axiosInstance.interceptors.response.use((response) => {
  return response
}, (error) => {
  return Promise.reject(error)
})

export default axiosInstance
